import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Profile/Addresses/adresses.container"
    ).then((module) => ({
        default: module.ProfileAddressesContainer
    }))
);
